import { useQuery } from "@tanstack/react-query";
import { getCase } from "@/lib/api";
import { queryKeys } from "@/lib/cache/queryKeys";
import { staleTimes } from "@/lib/cache/staleTimes";

export function useCase(caseId, { enabled = true } = {}) {
  return useQuery({
    queryKey: queryKeys.cases.detail(caseId),
    queryFn: () => getCase(caseId),
    staleTime: staleTimes.caseDetail,
    enabled: Boolean(caseId) && enabled,
  });
}
